import { Bell } from "@phosphor-icons/react";
import { usePublicStats } from "./DynamicGrantCount";

/**
 * ClosingSoonTicker
 *
 * Live count of active SC grants closing in the next 14 days. Reuses the
 * shared `usePublicStats` cache so the landing page only fires one stats
 * request even when multiple components consume it.
 *
 * Hides itself if the count is 0 (no fake urgency).
 */
const ClosingSoonTicker = () => {
  const stats = usePublicStats();
  const count = stats?.closing_next_14_days;

  if (!count || count === 0) return null;

  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-200"
      data-testid="closing-soon-ticker"
    >
      <Bell weight="fill" className="w-3.5 h-3.5 text-amber-300" />
      <span className="text-xs font-semibold tracking-wide">
        {count} SC grant{count === 1 ? "" : "s"} closing in the next 14 days. Start your draft.
      </span>
    </div>
  );
};

export default ClosingSoonTicker;
